var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-center"},[_c('div',{staticClass:"d-flex align-center"},[(_vm.display)?_c('v-icon',{staticClass:"mr-1",attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }